"use strict";
/**
 * Otzem Chassid Eye Clinic — design tokens.
 * Single source of truth consumed by:
 *  - apps/web        → CSS variables in globals.css + Tailwind preset
 *  - apps/mobile     → React Native Paper theme + StyleSheets
 *  - apps/server     → email + PDF (prescription letterhead) templates
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.appointmentStatusTone = exports.appointmentTypeColors = exports.radius = exports.spacing = exports.typography = exports.themes = exports.lightColors = exports.darkColors = void 0;
exports.darkColors = {
    bgPrimary: "#0f1a1f",
    bgSecondary: "#132028",
    bgTertiary: "#1a2d36",
    accent: "#1D9E75",
    accentLight: "#5DCAA5",
    accentSubtle: "#0F6E56",
    textPrimary: "#E2F0EB",
    textSecondary: "#8BA0A8",
    textTertiary: "#5F7A74",
    danger: "#E24B4A",
    warning: "#EF9F27",
    success: "#1D9E75",
    onAccent: "#0a1410",
    footerBg: "#0a1410",
};
exports.lightColors = {
    bgPrimary: "#FFFFFF",
    bgSecondary: "#F0FAF6",
    bgTertiary: "#E2F2EB",
    accent: "#0F6E56",
    accentLight: "#1D9E75",
    accentSubtle: "#BFE3D6",
    textPrimary: "#0a1410",
    textSecondary: "#3D5A52",
    textTertiary: "#7A968E",
    danger: "#C73534",
    warning: "#B97211",
    success: "#0F6E56",
    onAccent: "#FFFFFF",
    footerBg: "#0a1410",
};
exports.themes = {
    dark: exports.darkColors,
    light: exports.lightColors,
};
exports.typography = {
    fontFamily: '"Inter", system-ui, sans-serif',
    fontFamilySerif: "Georgia, serif",
    fontFamilyMono: '"JetBrains Mono", ui-monospace, monospace',
    scale: [12, 13, 14, 16, 18, 24, 30, 36],
    headingWeight: "600",
    bodyWeight: "400",
    headingLetterSpacing: -0.02, // em
    bodyLineHeight: 1.6,
};
exports.spacing = {
    xs: 4,
    sm: 8,
    md: 12,
    base: 16,
    lg: 24,
    xl: 32,
    "2xl": 48,
    "3xl": 64,
};
exports.radius = {
    input: 4,
    card: 8,
    modal: 12,
    pill: 9999,
};
/** Calendar / badge color per appointment type. */
exports.appointmentTypeColors = {
    ROUTINE: exports.darkColors.accent,
    FOLLOW_UP: exports.darkColors.accentLight,
    LENS_FITTING: exports.darkColors.warning,
    URGENT: exports.darkColors.danger,
    PHONE_CONSULT: exports.darkColors.textSecondary,
};
/** Badge tone per appointment status. */
exports.appointmentStatusTone = {
    SCHEDULED: "pending",
    CONFIRMED: "active",
    COMPLETED: "neutral",
    CANCELLED: "cancelled",
    NO_SHOW: "cancelled",
};
//# sourceMappingURL=tokens.js.map